/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto, FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoFromJSONTyped, FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoToJSON, } from './FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto';
export function FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionFromJSON(json) {
    return FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto(json)) {
        return FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionToJSON(json) {
    return FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionToJSONTyped(json, false);
}
export function FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDto(value)) {
        return FxIdApplicationHandlersDocumentsGetDocumentGameDocumentVersionDtoToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationHandlersDocumentsGetDocumentDocumentDtoLatestVersion.js.map